import React, { useCallback, useContext } from 'react'
import Clickable from '../Clickable'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import PriceRowPriceDetails from 'components/Luxkit/PricePoints/PriceRowPriceDetails'
import ModalContext from 'contexts/ModalContext'
import PriceDetailsModal from './PriceDetailsModal'
import IncludesTaxesAndFeesDetails from '../../Search/Hotels/IncludesTaxesAndFeeDetails'

type Props = {
  offerPage?: boolean;
  offer: App.Offer | App.BedbankOffer | App.OfferSummary | App.BedbankOfferSummary;
  duration: number;
  taxesAndFees?: number;
  propertyFees?: number;
  /** The price **without property fees** */
  hotelPrice: number;
  /** The member price **without property fees** */
  hotelMemberPrice?: number;
  showMemberPrice?: boolean;
  flightPrice?: number;
  otherFees?: {
    propertyFees: number;
    extraGuestsSurcharge: number;
  }
  rooms?: Array<App.Occupants>;
  extraGuestMessage?: string;
  dueAtPropertyMessage?: string;
  propertiesFees?: Array<App.PropertyFeesDetails>;
  cta?: React.ReactNode;
  onCtaAfterClose?: () => void;
  context?: 'search';
  hasMobilePromotion?: boolean
  hideIncludesTaxesAndFees?: boolean;
} & ({
  trigger: 'price-row'
  triggerSize: 'M' | 'L'
} | {
  trigger: 'info-icon'
  triggerSize?: undefined
})

function OfferPriceDetailsRow(props: Props) {
  const {
    trigger,
    triggerSize,
    context,
    hideIncludesTaxesAndFees = false,
    ...modalProps
  } = props

  const showModal = useContext(ModalContext)

  const openModal = useCallback(async() => {
    const result = await showModal<'fine-print' | undefined>(<PriceDetailsModal
      {...modalProps}
    />, true,
    )

    if (result === 'fine-print') {
      window.location.href = '#fine-print'
    }
  }, [modalProps, showModal])

  return (
    <>
      {trigger === 'price-row' && context === 'search' && !hideIncludesTaxesAndFees &&
        <IncludesTaxesAndFeesDetails size={triggerSize} onClick={openModal} />
      }
      {trigger === 'price-row' && context !== 'search' && <PriceRowPriceDetails size={triggerSize} onClick={openModal} />}
      {trigger === 'info-icon' && <Clickable onClick={openModal}><LineInfoCircleIcon /></Clickable>}
    </>
  )
}

export default OfferPriceDetailsRow
